export const trackEvent = (action, category, params = {}) => {
  if (!window.gtag) {
    console.warn('Google Analytics is not initialized.');
    return;
  }

  window.gtag('event', action, {
    event_category: category,
    ...params,
  });
};

/* Variables to keep track of analytics categories and common events so they're kept consistent */
export const NAVIGATION = 'navigation';
export const SELECT_COUNTY = 'select_county';
export const SELECT_LAYER = 'select_layer';
export const LAYER_OPACITY_CHANGE = 'layer_opacity_change';
export const MAP_SELECT_BASEMAP = 'map_select_basemap';
export const MAP_ADDRESS_SEARCH = 'map_address_search';
export const MAP_CROP_MODE = 'map_crop_mode';
export const MAP_DOWNLOAD = 'map_download';
export const MAP_DISTANCE_MEASURE = 'map_distance_measure';
export const COPY_CITATION = 'copy_citation';
export const LAYER_DOWNLOAD = 'layer_download';
